// Mirrors BookingStatus in hub/lib/consts.ex — update both when adding new statuses
export const bookingStatuses = {
  new: "new",
  staged: "staged",
  arrived: "arrived",
  trailerAttached: "trailer_attached",
  stagedArrived: "staged_arrived",
  inboundInProgress: "inbound_in_progress",
  outboundInProgress: "outbound_in_progress",
  readyForDriver: "ready_for_driver",
  completed: "completed",
  cancelled: "cancelled",
  queuedRebooking: "queued_rebooking"
};

export function getBookingStatusLabel(booking) {
  switch (booking.status) {
    case bookingStatuses.new:
      if (booking.direction == "inbound") {
        return "Awaiting arrival";
      } else {
        return "Awaiting trailer";
      }
    case bookingStatuses.staged:
      return "Staged";
    case bookingStatuses.arrived:
      return "Arrived on site";
    case bookingStatuses.trailerAttached:
      return "Trailer assigned";
    case bookingStatuses.stagedArrived:
      return "Staged arrived";
    case bookingStatuses.inboundInProgress:
      return "Unloading";
    case bookingStatuses.outboundInProgress:
      return "Loading";
    case bookingStatuses.readyForDriver:
      return "Ready for driver";
    case bookingStatuses.completed:
      return "Completed";
    case bookingStatuses.cancelled:
      return "Cancelled";
    case bookingStatuses.queuedRebooking:
      return "Queued rebooking";
    default:
      return "";
  }
}
